// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-axios';
import type { GetAsoiNotesData, GetAsoiNotesResponse, GetAsoiNotesError, GetAsoiNotesEmbargoData, GetAsoiNotesEmbargoResponse, GetAsoiNotesEmbargoError, DeleteAsoiNotesByNoteIdData, DeleteAsoiNotesByNoteIdError, GetAsoiNotesByNoteIdData, GetAsoiNotesByNoteIdResponse, GetAsoiNotesByNoteIdError, GetAsoiNotesByNoteIdEventsData, GetAsoiNotesByNoteIdEventsResponse, GetAsoiNotesByNoteIdEventsError, GetAsoiNotesByNoteIdHistoryData, GetAsoiNotesByNoteIdHistoryResponse, GetAsoiNotesByNoteIdHistoryError, PostAsoiNotesByNoteIdPickData, PostAsoiNotesByNoteIdPickResponse, PostAsoiNotesByNoteIdPickError, PostAsoiNotesByNoteIdReadData, PostAsoiNotesByNoteIdReadError, PostAuthData, PostAuthResponse, PostAuthError, PostAuthLostPasswordData, PostAuthLostPasswordError, PostAuthRefreshData, PostAuthRefreshResponse, PostAuthRefreshError, PostAuthResetPasswordData, PostAuthResetPasswordError, GetCodesData, GetCodesResponse, GetCodesError, GetCodesProfileData, GetCodesProfileError, GetEntitiesData, GetEntitiesResponse, GetEntitiesError, DeleteEntitiesAliasesByAliasIdData, DeleteEntitiesAliasesByAliasIdError, PatchEntitiesAliasesByAliasIdData, PatchEntitiesAliasesByAliasIdResponse, PatchEntitiesAliasesByAliasIdError, DeleteEntitiesPatternsByPatternIdData, DeleteEntitiesPatternsByPatternIdError, PatchEntitiesPatternsByPatternIdData, PatchEntitiesPatternsByPatternIdResponse, PatchEntitiesPatternsByPatternIdError, GetEntitiesTickersData, GetEntitiesTickersResponse, GetEntitiesTickersError, GetEntitiesByEntityIdData, GetEntitiesByEntityIdResponse, GetEntitiesByEntityIdError, PostEntitiesByEntityIdAliasesData, PostEntitiesByEntityIdAliasesResponse, PostEntitiesByEntityIdAliasesError, PostEntitiesByEntityIdPatternsData, PostEntitiesByEntityIdPatternsResponse, PostEntitiesByEntityIdPatternsError, GetFlowsData, GetFlowsResponse, GetFlowsError, PostFlowsData, PostFlowsResponse, PostFlowsError, DeleteFlowsByFlowIdData, DeleteFlowsByFlowIdError, GetFlowsByFlowIdData, GetFlowsByFlowIdResponse, GetFlowsByFlowIdError, PatchFlowsByFlowIdData, PatchFlowsByFlowIdResponse, PatchFlowsByFlowIdError, PostFlowsByFlowIdReadAllData, PostFlowsByFlowIdReadAllError, GetFlowsByFlowIdSourcesData, GetFlowsByFlowIdSourcesResponse, GetFlowsByFlowIdSourcesError, GetGroupsData, GetGroupsResponse, GetGroupsError, GetGroupsByGroupIdData, GetGroupsByGroupIdResponse, GetGroupsByGroupIdError, PatchGroupsByGroupIdData, PatchGroupsByGroupIdResponse, PatchGroupsByGroupIdError, GetGroupsByGroupIdPermissionsData, GetGroupsByGroupIdPermissionsResponse, GetGroupsByGroupIdPermissionsError, GetGroupsByGroupIdProfilesData, GetGroupsByGroupIdProfilesResponse, GetGroupsByGroupIdProfilesError, GetGroupsByGroupIdUsersData, GetGroupsByGroupIdUsersResponse, GetGroupsByGroupIdUsersError, GetGroupsAndUsersData, GetGroupsAndUsersResponse, GetGroupsAndUsersError, GetLeadsData, GetLeadsResponse, GetLeadsError, GetLeadsByLeadIdData, GetLeadsByLeadIdResponse, GetLeadsByLeadIdError, GetLeadsByLeadIdEventsData, GetLeadsByLeadIdEventsResponse, GetLeadsByLeadIdEventsError, PostLeadsByLeadIdForwardData, PostLeadsByLeadIdForwardResponse, PostLeadsByLeadIdForwardError, PostLeadsByLeadIdPickData, PostLeadsByLeadIdPickResponse, PostLeadsByLeadIdPickError, PostLeadsByLeadIdReadData, PostLeadsByLeadIdReadError, PostNewsData, PostNewsResponse, PostNewsError, GetNewsCanvasData, GetNewsCanvasResponse, GetNewsCanvasError, PatchNewsCanvasData, PatchNewsCanvasResponse, PatchNewsCanvasError, DeleteNewsCanvasCodesData, DeleteNewsCanvasCodesError, PostNewsCanvasCodesData, PostNewsCanvasCodesResponse, PostNewsCanvasCodesError, PostNewsCanvasPublishData, PostNewsCanvasPublishResponse, PostNewsCanvasPublishError, GetNewsDelayedData, GetNewsDelayedResponse, GetNewsDelayedError, PostNewsDisposeData, PostNewsDisposeResponse, PostNewsDisposeError, GetNewsDisposedData, GetNewsDisposedResponse, GetNewsDisposedError, GetNewsInProgressData, GetNewsInProgressResponse, GetNewsInProgressError, GetNewsMyData, GetNewsMyResponse, GetNewsMyError, GetNewsOriginalData, GetNewsOriginalResponse, GetNewsOriginalError, GetNewsPublishedData, GetNewsPublishedResponse, GetNewsPublishedError, GetNewsPublishedPresetsData, GetNewsPublishedPresetsResponse, GetNewsPublishedPresetsError, PostNewsPublishedPresetsData, PostNewsPublishedPresetsResponse, PostNewsPublishedPresetsError, DeleteNewsPublishedPresetsByPresetIdData, DeleteNewsPublishedPresetsByPresetIdError, PatchNewsPublishedPresetsByPresetIdData, PatchNewsPublishedPresetsByPresetIdResponse, PatchNewsPublishedPresetsByPresetIdError, PostNewsRescheduleData, PostNewsRescheduleResponse, PostNewsRescheduleError, GetNewsRoutesData, GetNewsRoutesResponse, GetNewsRoutesError, PatchNewsRoutesByRouteIdData, PatchNewsRoutesByRouteIdResponse, PatchNewsRoutesByRouteIdError, GetNewsSearchData, GetNewsSearchResponse, GetNewsSearchError, GetNewsWaitingData, GetNewsWaitingResponse, GetNewsWaitingError, DeleteNewsByNewsIdData, DeleteNewsByNewsIdError, GetNewsByNewsIdData, GetNewsByNewsIdResponse, GetNewsByNewsIdError, PatchNewsByNewsIdData, PatchNewsByNewsIdResponse, PatchNewsByNewsIdError, PostNewsByNewsIdAnnotateData, PostNewsByNewsIdAnnotateResponse, PostNewsByNewsIdAnnotateError, PostNewsByNewsIdAnnotateForbiddenData, PostNewsByNewsIdAnnotateForbiddenResponse, PostNewsByNewsIdAnnotateForbiddenError, GetNewsByNewsIdAsoiNoteData, GetNewsByNewsIdAsoiNoteResponse, GetNewsByNewsIdAsoiNoteError, GetNewsByNewsIdAuthorsData, GetNewsByNewsIdAuthorsResponse, GetNewsByNewsIdAuthorsError, PostNewsByNewsIdAuthorsData, PostNewsByNewsIdAuthorsResponse, PostNewsByNewsIdAuthorsError, DeleteNewsByNewsIdAuthorsByUserIdData, DeleteNewsByNewsIdAuthorsByUserIdError, DeleteNewsByNewsIdCodesData, DeleteNewsByNewsIdCodesError, GetNewsByNewsIdCodesData, GetNewsByNewsIdCodesResponse, GetNewsByNewsIdCodesError, PostNewsByNewsIdCodesData, PostNewsByNewsIdCodesResponse, PostNewsByNewsIdCodesError, GetNewsByNewsIdCommentsData, GetNewsByNewsIdCommentsResponse, GetNewsByNewsIdCommentsError, PostNewsByNewsIdCommentsData, PostNewsByNewsIdCommentsResponse, PostNewsByNewsIdCommentsError, PostNewsByNewsIdCommentsByCommentIdReadData, PostNewsByNewsIdCommentsByCommentIdReadResponse, PostNewsByNewsIdCommentsByCommentIdReadError, GetNewsByNewsIdEventsData, GetNewsByNewsIdEventsResponse, GetNewsByNewsIdEventsError, PostNewsByNewsIdExtendData, PostNewsByNewsIdExtendResponse, PostNewsByNewsIdExtendError, GetNewsByNewsIdLinksData, GetNewsByNewsIdLinksResponse, GetNewsByNewsIdLinksError, DeleteNewsByNewsIdLinksByChildIdByTypeIdData, DeleteNewsByNewsIdLinksByChildIdByTypeIdError, GetNewsByNewsIdNotificationsData, GetNewsByNewsIdNotificationsResponse, GetNewsByNewsIdNotificationsError, PostNewsByNewsIdNotificationsData, PostNewsByNewsIdNotificationsResponse, PostNewsByNewsIdNotificationsError, GetNewsByNewsIdOriginalData, GetNewsByNewsIdOriginalResponse, GetNewsByNewsIdOriginalError, PostNewsByNewsIdPickData, PostNewsByNewsIdPickResponse, PostNewsByNewsIdPickError, PostNewsByNewsIdPublishData, PostNewsByNewsIdPublishResponse, PostNewsByNewsIdPublishError, PostNewsByNewsIdReadData, PostNewsByNewsIdReadResponse, PostNewsByNewsIdReadError, PostNewsByNewsIdRecallData, PostNewsByNewsIdRecallResponse, PostNewsByNewsIdRecallError, GetNewsByNewsIdRelationsData, GetNewsByNewsIdRelationsResponse, GetNewsByNewsIdRelationsError, PostNewsByNewsIdRepublishData, PostNewsByNewsIdRepublishResponse, PostNewsByNewsIdRepublishError, PostNewsByNewsIdRepublishUneditedData, PostNewsByNewsIdRepublishUneditedResponse, PostNewsByNewsIdRepublishUneditedError, PostNewsByNewsIdRevokeData, PostNewsByNewsIdRevokeResponse, PostNewsByNewsIdRevokeError, PatchNewsByNewsIdRouteCodesData, PatchNewsByNewsIdRouteCodesResponse, PatchNewsByNewsIdRouteCodesError, PostNewsByNewsIdSendData, PostNewsByNewsIdSendResponse, PostNewsByNewsIdSendError, PostNewsByNewsIdSendToAsoiData, PostNewsByNewsIdSendToAsoiResponse, PostNewsByNewsIdSendToAsoiError, PostNewsByNewsIdValidateData, PostNewsByNewsIdValidateError, GetNewsByNewsIdVersionsData, GetNewsByNewsIdVersionsResponse, GetNewsByNewsIdVersionsError, GetNewsbreaksData, GetNewsbreaksResponse, GetNewsbreaksError, GetNewsbreaksByNewsbreakIdData, GetNewsbreaksByNewsbreakIdResponse, GetNewsbreaksByNewsbreakIdError, GetNewsbreaksByNewsbreakIdEventsData, GetNewsbreaksByNewsbreakIdEventsResponse, GetNewsbreaksByNewsbreakIdEventsError, PostNewsbreaksByNewsbreakIdPickData, PostNewsbreaksByNewsbreakIdPickResponse, PostNewsbreaksByNewsbreakIdPickError, PostNewsbreaksByNewsbreakIdReadData, PostNewsbreaksByNewsbreakIdReadResponse, PostNewsbreaksByNewsbreakIdReadError, PostNewsbreaksByNewsbreakIdRejectData, PostNewsbreaksByNewsbreakIdRejectResponse, PostNewsbreaksByNewsbreakIdRejectError, GetNotificationsData, GetNotificationsResponse, GetNotificationsError, PostNotificationsData, PostNotificationsResponse, PostNotificationsError, DeleteNotificationsApnsV1DevicesByDeviceTokenRegistrationsByWebsitePushIdData, DeleteNotificationsApnsV1DevicesByDeviceTokenRegistrationsByWebsitePushIdError, PostNotificationsApnsV1DevicesByDeviceTokenRegistrationsByWebsitePushIdData, PostNotificationsApnsV1DevicesByDeviceTokenRegistrationsByWebsitePushIdResponse, PostNotificationsApnsV1DevicesByDeviceTokenRegistrationsByWebsitePushIdError, PostNotificationsApnsV1LogData, PostNotificationsApnsV1LogError, PostNotificationsApnsV2PushPackagesByWebsitePushIdData, PostNotificationsApnsV2PushPackagesByWebsitePushIdError, PostNotificationsSubscriptionsData, PostNotificationsSubscriptionsResponse, PostNotificationsSubscriptionsError, DeleteNotificationsSubscriptionsBySubscriptionIdData, DeleteNotificationsSubscriptionsBySubscriptionIdError, GetPermissionsData, GetPermissionsResponse, GetPermissionsError, PostPermissionsByPermissionIdGroupsData, PostPermissionsByPermissionIdGroupsResponse, PostPermissionsByPermissionIdGroupsError, DeletePermissionsByPermissionIdGroupsByGroupIdData, DeletePermissionsByPermissionIdGroupsByGroupIdError, PostPermissionsByPermissionIdGroupsByGroupIdTargetGroupsData, PostPermissionsByPermissionIdGroupsByGroupIdTargetGroupsResponse, PostPermissionsByPermissionIdGroupsByGroupIdTargetGroupsError, DeletePermissionsByPermissionIdGroupsByGroupIdTargetGroupsByTargetGroupIdData, DeletePermissionsByPermissionIdGroupsByGroupIdTargetGroupsByTargetGroupIdError, PostPermissionsByPermissionIdGroupsByGroupIdTargetUsersData, PostPermissionsByPermissionIdGroupsByGroupIdTargetUsersResponse, PostPermissionsByPermissionIdGroupsByGroupIdTargetUsersError, DeletePermissionsByPermissionIdGroupsByGroupIdTargetUsersByTargetUserIdData, DeletePermissionsByPermissionIdGroupsByGroupIdTargetUsersByTargetUserIdError, PatchPermissionsByPermissionIdGroupsByGroupIdTargetUsersByTargetUserIdData, PatchPermissionsByPermissionIdGroupsByGroupIdTargetUsersByTargetUserIdResponse, PatchPermissionsByPermissionIdGroupsByGroupIdTargetUsersByTargetUserIdError, GetPermissionsByPermissionIdOwnersData, GetPermissionsByPermissionIdOwnersResponse, GetPermissionsByPermissionIdOwnersError, PostPermissionsByPermissionIdUsersData, PostPermissionsByPermissionIdUsersResponse, PostPermissionsByPermissionIdUsersError, DeletePermissionsByPermissionIdUsersByUserIdData, DeletePermissionsByPermissionIdUsersByUserIdError, PatchPermissionsByPermissionIdUsersByUserIdData, PatchPermissionsByPermissionIdUsersByUserIdResponse, PatchPermissionsByPermissionIdUsersByUserIdError, PostPermissionsByPermissionIdUsersByUserIdTargetGroupsData, PostPermissionsByPermissionIdUsersByUserIdTargetGroupsResponse, PostPermissionsByPermissionIdUsersByUserIdTargetGroupsError, DeletePermissionsByPermissionIdUsersByUserIdTargetGroupsByTargetGroupIdData, DeletePermissionsByPermissionIdUsersByUserIdTargetGroupsByTargetGroupIdError, PostPermissionsByPermissionIdUsersByUserIdTargetUsersData, PostPermissionsByPermissionIdUsersByUserIdTargetUsersResponse, PostPermissionsByPermissionIdUsersByUserIdTargetUsersError, DeletePermissionsByPermissionIdUsersByUserIdTargetUsersByTargetUserIdData, DeletePermissionsByPermissionIdUsersByUserIdTargetUsersByTargetUserIdError, PatchPermissionsByPermissionIdUsersByUserIdTargetUsersByTargetUserIdData, PatchPermissionsByPermissionIdUsersByUserIdTargetUsersByTargetUserIdResponse, PatchPermissionsByPermissionIdUsersByUserIdTargetUsersByTargetUserIdError, GetProfileData, GetProfileResponse, GetProfileError, PatchProfileData, PatchProfileResponse, PatchProfileError, GetReferencesData, GetReferencesResponse, GetReferencesError, DeleteSourcesData, DeleteSourcesError, GetSourcesData, GetSourcesResponse, GetSourcesError, PostSourcesData, PostSourcesResponse, PostSourcesError, DeleteSourcesBySourceIdData, DeleteSourcesBySourceIdError, GetSourcesBySourceIdData, GetSourcesBySourceIdResponse, GetSourcesBySourceIdError, PatchSourcesBySourceIdData, PatchSourcesBySourceIdResponse, PatchSourcesBySourceIdError, GetSourcesBySourceIdErrorsData, GetSourcesBySourceIdErrorsResponse, GetSourcesBySourceIdErrorsError, GetSourcesBySourceIdLogsData, GetSourcesBySourceIdLogsResponse, GetSourcesBySourceIdLogsError, GetUsersData, GetUsersResponse, GetUsersError, PostUsersData, PostUsersResponse, PostUsersError, GetUsersStatusesData, GetUsersStatusesResponse, GetUsersStatusesError, PostUsersStatusesOnlineData, PostUsersStatusesOnlineError, GetUsersByUserIdData, GetUsersByUserIdResponse, GetUsersByUserIdError, PatchUsersByUserIdData, PatchUsersByUserIdResponse, PatchUsersByUserIdError, GetUsersByUserIdGroupsData, GetUsersByUserIdGroupsResponse, GetUsersByUserIdGroupsError, GetUsersByUserIdPermissionsData, GetUsersByUserIdPermissionsResponse, GetUsersByUserIdPermissionsError, GetUsersByUserIdProfilesData, GetUsersByUserIdProfilesResponse, GetUsersByUserIdProfilesError } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class AsoiService {
    /**
     * Вернуть список заметок АСОИ.
     *
     * Пользователь видит заметки, которые:
     * 1. Пришли на его личный ящик (`User.asoi_mailbox_id`)
     * 2. Пришли на ящики, на которые у пользователя есть подписка (таблица
     * `asoi_user_mailbox`)
     * 3. Пришли на личные ящики пользователей из групп, на которые у
     * пользователя есть подписка с флагом `includes_group_users=True`
     */
    public static getAsoiNotes<ThrowOnError extends boolean = false>(options: Options<GetAsoiNotesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetAsoiNotesResponse, GetAsoiNotesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/asoi_notes/',
            ...options
        });
    }
    
    /**
     * Вернуть список заметок АСОИ с эмбарго.
     */
    public static getAsoiNotesEmbargo<ThrowOnError extends boolean = false>(options: Options<GetAsoiNotesEmbargoData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetAsoiNotesEmbargoResponse, GetAsoiNotesEmbargoError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/asoi_notes/embargo/',
            ...options
        });
    }
    
    /**
     * Удалить заметку АСОИ.
     */
    public static deleteAsoiNotesByNoteId<ThrowOnError extends boolean = false>(options: Options<DeleteAsoiNotesByNoteIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteAsoiNotesByNoteIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/asoi_notes/{note_id}/',
            ...options
        });
    }
    
    /**
     * Вернуть заметку АСОИ.
     */
    public static getAsoiNotesByNoteId<ThrowOnError extends boolean = false>(options: Options<GetAsoiNotesByNoteIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetAsoiNotesByNoteIdResponse, GetAsoiNotesByNoteIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/asoi_notes/{note_id}/',
            ...options
        });
    }
    
    /**
     * Вернуть список событий заметки АСОИ.
     */
    public static getAsoiNotesByNoteIdEvents<ThrowOnError extends boolean = false>(options: Options<GetAsoiNotesByNoteIdEventsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetAsoiNotesByNoteIdEventsResponse, GetAsoiNotesByNoteIdEventsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/asoi_notes/{note_id}/events/',
            ...options
        });
    }
    
    /**
     * Вернуть историю действий над заметкой АСОИ.
     */
    public static getAsoiNotesByNoteIdHistory<ThrowOnError extends boolean = false>(options: Options<GetAsoiNotesByNoteIdHistoryData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetAsoiNotesByNoteIdHistoryResponse, GetAsoiNotesByNoteIdHistoryError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/asoi_notes/{note_id}/history/',
            ...options
        });
    }
    
    /**
     * Взять заметку АСОИ в работу.
     *
     * На основе заметки создается черновик новости.
     */
    public static postAsoiNotesByNoteIdPick<ThrowOnError extends boolean = false>(options: Options<PostAsoiNotesByNoteIdPickData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostAsoiNotesByNoteIdPickResponse, PostAsoiNotesByNoteIdPickError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/asoi_notes/{note_id}/pick/',
            ...options
        });
    }
    
    /**
     * Прочитать заметку АСОИ.
     */
    public static postAsoiNotesByNoteIdRead<ThrowOnError extends boolean = false>(options: Options<PostAsoiNotesByNoteIdReadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, PostAsoiNotesByNoteIdReadError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/asoi_notes/{note_id}/read/',
            ...options
        });
    }
    
}

export class AuthService {
    /**
     * Сформировать токен доступа и рефреш-токен.
     */
    public static postAuth<ThrowOnError extends boolean = false>(options: Options<PostAuthData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostAuthResponse, PostAuthError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/auth/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Сформировать токен для сброса пароля и отправить ссылку на email
     * пользователя.
     */
    public static postAuthLostPassword<ThrowOnError extends boolean = false>(options: Options<PostAuthLostPasswordData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, PostAuthLostPasswordError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/auth/lost_password/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Обновить токен доступа и рефреш-токен.
     */
    public static postAuthRefresh<ThrowOnError extends boolean = false>(options?: Options<PostAuthRefreshData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<PostAuthRefreshResponse, PostAuthRefreshError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/auth/refresh/',
            ...options
        });
    }
    
    /**
     * Сформировать и отправить новый пароль пользователя на email
     * пользователя.
     */
    public static postAuthResetPassword<ThrowOnError extends boolean = false>(options: Options<PostAuthResetPasswordData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, PostAuthResetPasswordError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/auth/reset_password/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CodesService {
    /**
     * Вернуть дерево кодов.
     */
    public static getCodes<ThrowOnError extends boolean = false>(options?: Options<GetCodesData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetCodesResponse, GetCodesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/codes/',
            ...options
        });
    }
    
    /**
     * Вернуть дерево кодов, доступных пользователю в зависимости от того,
     * какие профили кодов заданы для него или для групп, в которых он
     * состоит.
     */
    public static getCodesProfile<ThrowOnError extends boolean = false>(options: Options<GetCodesProfileData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<unknown, GetCodesProfileError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/codes/profile/',
            ...options
        });
    }
    
    /**
     * Вернуть список профилей кодов группы.
     */
    public static getGroupsByGroupIdProfiles<ThrowOnError extends boolean = false>(options: Options<GetGroupsByGroupIdProfilesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetGroupsByGroupIdProfilesResponse, GetGroupsByGroupIdProfilesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/groups/{group_id}/profiles/',
            ...options
        });
    }
    
    /**
     * Вернуть список профилей кодов пользователя.
     */
    public static getUsersByUserIdProfiles<ThrowOnError extends boolean = false>(options: Options<GetUsersByUserIdProfilesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetUsersByUserIdProfilesResponse, GetUsersByUserIdProfilesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/users/{user_id}/profiles/',
            ...options
        });
    }
    
}

export class EntitiesService {
    /**
     * Вернуть список сущностей.
     */
    public static getEntities<ThrowOnError extends boolean = false>(options: Options<GetEntitiesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetEntitiesResponse, GetEntitiesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/entities/',
            ...options
        });
    }
    
    /**
     * Удалить алиас сущности.
     */
    public static deleteEntitiesAliasesByAliasId<ThrowOnError extends boolean = false>(options: Options<DeleteEntitiesAliasesByAliasIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteEntitiesAliasesByAliasIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/entities/aliases/{alias_id}/',
            ...options
        });
    }
    
    /**
     * Обновить данные алиаса сущности.
     */
    public static patchEntitiesAliasesByAliasId<ThrowOnError extends boolean = false>(options: Options<PatchEntitiesAliasesByAliasIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchEntitiesAliasesByAliasIdResponse, PatchEntitiesAliasesByAliasIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/entities/aliases/{alias_id}/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить паттерн сущности.
     */
    public static deleteEntitiesPatternsByPatternId<ThrowOnError extends boolean = false>(options: Options<DeleteEntitiesPatternsByPatternIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteEntitiesPatternsByPatternIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/entities/patterns/{pattern_id}/',
            ...options
        });
    }
    
    /**
     * Обновить данные паттерна сущности.
     */
    public static patchEntitiesPatternsByPatternId<ThrowOnError extends boolean = false>(options: Options<PatchEntitiesPatternsByPatternIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchEntitiesPatternsByPatternIdResponse, PatchEntitiesPatternsByPatternIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/entities/patterns/{pattern_id}/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть список сущностей с тикерами компаний.
     */
    public static getEntitiesTickers<ThrowOnError extends boolean = false>(options: Options<GetEntitiesTickersData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetEntitiesTickersResponse, GetEntitiesTickersError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/entities/tickers/',
            ...options
        });
    }
    
    /**
     * Вернуть сущность.
     */
    public static getEntitiesByEntityId<ThrowOnError extends boolean = false>(options: Options<GetEntitiesByEntityIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetEntitiesByEntityIdResponse, GetEntitiesByEntityIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/entities/{entity_id}/',
            ...options
        });
    }
    
    /**
     * Добавить алиасы сущности.
     */
    public static postEntitiesByEntityIdAliases<ThrowOnError extends boolean = false>(options: Options<PostEntitiesByEntityIdAliasesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostEntitiesByEntityIdAliasesResponse, PostEntitiesByEntityIdAliasesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/entities/{entity_id}/aliases/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Добавить паттерны сущности.
     */
    public static postEntitiesByEntityIdPatterns<ThrowOnError extends boolean = false>(options: Options<PostEntitiesByEntityIdPatternsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostEntitiesByEntityIdPatternsResponse, PostEntitiesByEntityIdPatternsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/entities/{entity_id}/patterns/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class FlowsService {
    /**
     * Вернуть список потоков.
     */
    public static getFlows<ThrowOnError extends boolean = false>(options: Options<GetFlowsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetFlowsResponse, GetFlowsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/flows/',
            ...options
        });
    }
    
    /**
     * Добавить поток.
     */
    public static postFlows<ThrowOnError extends boolean = false>(options: Options<PostFlowsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostFlowsResponse, PostFlowsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/flows/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить поток.
     */
    public static deleteFlowsByFlowId<ThrowOnError extends boolean = false>(options: Options<DeleteFlowsByFlowIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteFlowsByFlowIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/flows/{flow_id}/',
            ...options
        });
    }
    
    /**
     * Вернуть поток.
     */
    public static getFlowsByFlowId<ThrowOnError extends boolean = false>(options: Options<GetFlowsByFlowIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetFlowsByFlowIdResponse, GetFlowsByFlowIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/flows/{flow_id}/',
            ...options
        });
    }
    
    /**
     * Обновить поток.
     */
    public static patchFlowsByFlowId<ThrowOnError extends boolean = false>(options: Options<PatchFlowsByFlowIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchFlowsByFlowIdResponse, PatchFlowsByFlowIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/flows/{flow_id}/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Пометить все лиды в потоке как прочитанные пользователем.
     */
    public static postFlowsByFlowIdReadAll<ThrowOnError extends boolean = false>(options: Options<PostFlowsByFlowIdReadAllData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, PostFlowsByFlowIdReadAllError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/flows/{flow_id}/read_all/',
            ...options
        });
    }
    
    /**
     * Вернуть список источников.
     */
    public static getFlowsByFlowIdSources<ThrowOnError extends boolean = false>(options: Options<GetFlowsByFlowIdSourcesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetFlowsByFlowIdSourcesResponse, GetFlowsByFlowIdSourcesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/flows/{flow_id}/sources/',
            ...options
        });
    }
    
}

export class GroupsService {
    /**
     * Вернуть список групп.
     */
    public static getGroups<ThrowOnError extends boolean = false>(options: Options<GetGroupsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetGroupsResponse, GetGroupsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/groups/',
            ...options
        });
    }
    
    /**
     * Вернуть группу.
     */
    public static getGroupsByGroupId<ThrowOnError extends boolean = false>(options: Options<GetGroupsByGroupIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetGroupsByGroupIdResponse, GetGroupsByGroupIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/groups/{group_id}/',
            ...options
        });
    }
    
    /**
     * Обновить группу.
     */
    public static patchGroupsByGroupId<ThrowOnError extends boolean = false>(options: Options<PatchGroupsByGroupIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchGroupsByGroupIdResponse, PatchGroupsByGroupIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/groups/{group_id}/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть список разрешений группы.
     */
    public static getGroupsByGroupIdPermissions<ThrowOnError extends boolean = false>(options: Options<GetGroupsByGroupIdPermissionsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetGroupsByGroupIdPermissionsResponse, GetGroupsByGroupIdPermissionsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/groups/{group_id}/permissions/',
            ...options
        });
    }
    
    /**
     * Вернуть список профилей кодов группы.
     */
    public static getGroupsByGroupIdProfiles<ThrowOnError extends boolean = false>(options: Options<GetGroupsByGroupIdProfilesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetGroupsByGroupIdProfilesResponse, GetGroupsByGroupIdProfilesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/groups/{group_id}/profiles/',
            ...options
        });
    }
    
    /**
     * Вернуть список пользователей в группе.
     */
    public static getGroupsByGroupIdUsers<ThrowOnError extends boolean = false>(options: Options<GetGroupsByGroupIdUsersData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetGroupsByGroupIdUsersResponse, GetGroupsByGroupIdUsersError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/groups/{group_id}/users/',
            ...options
        });
    }
    
    /**
     * Вернуть списки групп с пользователями и пользователей без групп.
     */
    public static getGroupsAndUsers<ThrowOnError extends boolean = false>(options?: Options<GetGroupsAndUsersData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetGroupsAndUsersResponse, GetGroupsAndUsersError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/groups_and_users/',
            ...options
        });
    }
    
    /**
     * Вернуть список групп пользователя.
     */
    public static getUsersByUserIdGroups<ThrowOnError extends boolean = false>(options: Options<GetUsersByUserIdGroupsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetUsersByUserIdGroupsResponse, GetUsersByUserIdGroupsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/users/{user_id}/groups/',
            ...options
        });
    }
    
}

export class PermissionsService {
    /**
     * Вернуть список разрешений группы.
     */
    public static getGroupsByGroupIdPermissions<ThrowOnError extends boolean = false>(options: Options<GetGroupsByGroupIdPermissionsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetGroupsByGroupIdPermissionsResponse, GetGroupsByGroupIdPermissionsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/groups/{group_id}/permissions/',
            ...options
        });
    }
    
    /**
     * Вернуть список категорий разрешений и разрешений, относящихся к ним.
     */
    public static getPermissions<ThrowOnError extends boolean = false>(options?: Options<GetPermissionsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetPermissionsResponse, GetPermissionsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/',
            ...options
        });
    }
    
    /**
     * Добавить разрешение группам.
     */
    public static postPermissionsByPermissionIdGroups<ThrowOnError extends boolean = false>(options: Options<PostPermissionsByPermissionIdGroupsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostPermissionsByPermissionIdGroupsResponse, PostPermissionsByPermissionIdGroupsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/groups/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить разрешение у группы.
     */
    public static deletePermissionsByPermissionIdGroupsByGroupId<ThrowOnError extends boolean = false>(options: Options<DeletePermissionsByPermissionIdGroupsByGroupIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeletePermissionsByPermissionIdGroupsByGroupIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/groups/{group_id}/',
            ...options
        });
    }
    
    /**
     * Добавить группу, в отношении которой действует разрешение.
     */
    public static postPermissionsByPermissionIdGroupsByGroupIdTargetGroups<ThrowOnError extends boolean = false>(options: Options<PostPermissionsByPermissionIdGroupsByGroupIdTargetGroupsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostPermissionsByPermissionIdGroupsByGroupIdTargetGroupsResponse, PostPermissionsByPermissionIdGroupsByGroupIdTargetGroupsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/groups/{group_id}/target_groups/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить группу, в отношении которой действует разрешение.
     */
    public static deletePermissionsByPermissionIdGroupsByGroupIdTargetGroupsByTargetGroupId<ThrowOnError extends boolean = false>(options: Options<DeletePermissionsByPermissionIdGroupsByGroupIdTargetGroupsByTargetGroupIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeletePermissionsByPermissionIdGroupsByGroupIdTargetGroupsByTargetGroupIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/groups/{group_id}/target_groups/{target_group_id}/',
            ...options
        });
    }
    
    /**
     * Добавить пользователя, в отношении которого действует разрешение.
     */
    public static postPermissionsByPermissionIdGroupsByGroupIdTargetUsers<ThrowOnError extends boolean = false>(options: Options<PostPermissionsByPermissionIdGroupsByGroupIdTargetUsersData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostPermissionsByPermissionIdGroupsByGroupIdTargetUsersResponse, PostPermissionsByPermissionIdGroupsByGroupIdTargetUsersError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/groups/{group_id}/target_users/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить пользователя, в отношении которого действует разрешение.
     */
    public static deletePermissionsByPermissionIdGroupsByGroupIdTargetUsersByTargetUserId<ThrowOnError extends boolean = false>(options: Options<DeletePermissionsByPermissionIdGroupsByGroupIdTargetUsersByTargetUserIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeletePermissionsByPermissionIdGroupsByGroupIdTargetUsersByTargetUserIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/groups/{group_id}/target_users/{target_user_id}/',
            ...options
        });
    }
    
    /**
     * Обновить данные пользователя, в отношении которого действует
     * разрешение.
     */
    public static patchPermissionsByPermissionIdGroupsByGroupIdTargetUsersByTargetUserId<ThrowOnError extends boolean = false>(options: Options<PatchPermissionsByPermissionIdGroupsByGroupIdTargetUsersByTargetUserIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchPermissionsByPermissionIdGroupsByGroupIdTargetUsersByTargetUserIdResponse, PatchPermissionsByPermissionIdGroupsByGroupIdTargetUsersByTargetUserIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/groups/{group_id}/target_users/{target_user_id}/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть списки групп и пользователей, владеющих разрешением.
     */
    public static getPermissionsByPermissionIdOwners<ThrowOnError extends boolean = false>(options: Options<GetPermissionsByPermissionIdOwnersData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetPermissionsByPermissionIdOwnersResponse, GetPermissionsByPermissionIdOwnersError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/owners/',
            ...options
        });
    }
    
    /**
     * Добавить разрешение пользователям.
     */
    public static postPermissionsByPermissionIdUsers<ThrowOnError extends boolean = false>(options: Options<PostPermissionsByPermissionIdUsersData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostPermissionsByPermissionIdUsersResponse, PostPermissionsByPermissionIdUsersError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/users/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить разрешение у пользователя.
     */
    public static deletePermissionsByPermissionIdUsersByUserId<ThrowOnError extends boolean = false>(options: Options<DeletePermissionsByPermissionIdUsersByUserIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeletePermissionsByPermissionIdUsersByUserIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/users/{user_id}/',
            ...options
        });
    }
    
    /**
     * Обновить данные разрешения пользователя.
     */
    public static patchPermissionsByPermissionIdUsersByUserId<ThrowOnError extends boolean = false>(options: Options<PatchPermissionsByPermissionIdUsersByUserIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchPermissionsByPermissionIdUsersByUserIdResponse, PatchPermissionsByPermissionIdUsersByUserIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/users/{user_id}/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Добавить группу, в отношении которой действует разрешение.
     */
    public static postPermissionsByPermissionIdUsersByUserIdTargetGroups<ThrowOnError extends boolean = false>(options: Options<PostPermissionsByPermissionIdUsersByUserIdTargetGroupsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostPermissionsByPermissionIdUsersByUserIdTargetGroupsResponse, PostPermissionsByPermissionIdUsersByUserIdTargetGroupsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/users/{user_id}/target_groups/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить группу, в отношении которой действует разрешение.
     */
    public static deletePermissionsByPermissionIdUsersByUserIdTargetGroupsByTargetGroupId<ThrowOnError extends boolean = false>(options: Options<DeletePermissionsByPermissionIdUsersByUserIdTargetGroupsByTargetGroupIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeletePermissionsByPermissionIdUsersByUserIdTargetGroupsByTargetGroupIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/users/{user_id}/target_groups/{target_group_id}/',
            ...options
        });
    }
    
    /**
     * Добавить пользователя, в отношении которого действует разрешение.
     */
    public static postPermissionsByPermissionIdUsersByUserIdTargetUsers<ThrowOnError extends boolean = false>(options: Options<PostPermissionsByPermissionIdUsersByUserIdTargetUsersData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostPermissionsByPermissionIdUsersByUserIdTargetUsersResponse, PostPermissionsByPermissionIdUsersByUserIdTargetUsersError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/users/{user_id}/target_users/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить пользователя, в отношении которого действует разрешение.
     */
    public static deletePermissionsByPermissionIdUsersByUserIdTargetUsersByTargetUserId<ThrowOnError extends boolean = false>(options: Options<DeletePermissionsByPermissionIdUsersByUserIdTargetUsersByTargetUserIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeletePermissionsByPermissionIdUsersByUserIdTargetUsersByTargetUserIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/users/{user_id}/target_users/{target_user_id}/',
            ...options
        });
    }
    
    /**
     * Обновить данные пользователя, в отношении которого действует
     * разрешение.
     */
    public static patchPermissionsByPermissionIdUsersByUserIdTargetUsersByTargetUserId<ThrowOnError extends boolean = false>(options: Options<PatchPermissionsByPermissionIdUsersByUserIdTargetUsersByTargetUserIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchPermissionsByPermissionIdUsersByUserIdTargetUsersByTargetUserIdResponse, PatchPermissionsByPermissionIdUsersByUserIdTargetUsersByTargetUserIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/permissions/{permission_id}/users/{user_id}/target_users/{target_user_id}/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть список разрешений пользователя.
     */
    public static getUsersByUserIdPermissions<ThrowOnError extends boolean = false>(options: Options<GetUsersByUserIdPermissionsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetUsersByUserIdPermissionsResponse, GetUsersByUserIdPermissionsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/users/{user_id}/permissions/',
            ...options
        });
    }
    
}

export class UsersService {
    /**
     * Вернуть список пользователей в группе.
     */
    public static getGroupsByGroupIdUsers<ThrowOnError extends boolean = false>(options: Options<GetGroupsByGroupIdUsersData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetGroupsByGroupIdUsersResponse, GetGroupsByGroupIdUsersError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/groups/{group_id}/users/',
            ...options
        });
    }
    
    /**
     * Вернуть списки групп с пользователями и пользователей без групп.
     */
    public static getGroupsAndUsers<ThrowOnError extends boolean = false>(options?: Options<GetGroupsAndUsersData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetGroupsAndUsersResponse, GetGroupsAndUsersError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/groups_and_users/',
            ...options
        });
    }
    
    /**
     * Вернуть данные профиля.
     */
    public static getProfile<ThrowOnError extends boolean = false>(options?: Options<GetProfileData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetProfileResponse, GetProfileError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/profile/',
            ...options
        });
    }
    
    /**
     * Обновить данные профиля.
     */
    public static patchProfile<ThrowOnError extends boolean = false>(options: Options<PatchProfileData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchProfileResponse, PatchProfileError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/profile/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть список пользователей.
     */
    public static getUsers<ThrowOnError extends boolean = false>(options: Options<GetUsersData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetUsersResponse, GetUsersError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/users/',
            ...options
        });
    }
    
    /**
     * Добавить пользователя.
     */
    public static postUsers<ThrowOnError extends boolean = false>(options: Options<PostUsersData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostUsersResponse, PostUsersError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/users/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть статусы пользователей.
     */
    public static getUsersStatuses<ThrowOnError extends boolean = false>(options?: Options<GetUsersStatusesData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetUsersStatusesResponse, GetUsersStatusesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/users/statuses/',
            ...options
        });
    }
    
    /**
     * Изменить статус текущего пользователя на онлайн.
     */
    public static postUsersStatusesOnline<ThrowOnError extends boolean = false>(options?: Options<PostUsersStatusesOnlineData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<unknown, PostUsersStatusesOnlineError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/users/statuses/online/',
            ...options
        });
    }
    
    /**
     * Вернуть пользователя.
     */
    public static getUsersByUserId<ThrowOnError extends boolean = false>(options: Options<GetUsersByUserIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetUsersByUserIdResponse, GetUsersByUserIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/users/{user_id}/',
            ...options
        });
    }
    
    /**
     * Обновить пользователя.
     */
    public static patchUsersByUserId<ThrowOnError extends boolean = false>(options: Options<PatchUsersByUserIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchUsersByUserIdResponse, PatchUsersByUserIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/users/{user_id}/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть список групп пользователя.
     */
    public static getUsersByUserIdGroups<ThrowOnError extends boolean = false>(options: Options<GetUsersByUserIdGroupsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetUsersByUserIdGroupsResponse, GetUsersByUserIdGroupsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/users/{user_id}/groups/',
            ...options
        });
    }
    
    /**
     * Вернуть список разрешений пользователя.
     */
    public static getUsersByUserIdPermissions<ThrowOnError extends boolean = false>(options: Options<GetUsersByUserIdPermissionsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetUsersByUserIdPermissionsResponse, GetUsersByUserIdPermissionsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/users/{user_id}/permissions/',
            ...options
        });
    }
    
    /**
     * Вернуть список профилей кодов пользователя.
     */
    public static getUsersByUserIdProfiles<ThrowOnError extends boolean = false>(options: Options<GetUsersByUserIdProfilesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetUsersByUserIdProfilesResponse, GetUsersByUserIdProfilesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/users/{user_id}/profiles/',
            ...options
        });
    }
    
}

export class LeadsService {
    /**
     * Вернуть список лидов в потоке.
     */
    public static getLeads<ThrowOnError extends boolean = false>(options: Options<GetLeadsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetLeadsResponse, GetLeadsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/leads/',
            ...options
        });
    }
    
    /**
     * Вернуть лид.
     *
     * Сначала искать временный лид.  Если он не найден, то искать постоянный
     * лид.
     */
    public static getLeadsByLeadId<ThrowOnError extends boolean = false>(options: Options<GetLeadsByLeadIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetLeadsByLeadIdResponse, GetLeadsByLeadIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/leads/{lead_id}/',
            ...options
        });
    }
    
    /**
     * Вернуть список событий.
     *
     * Не выполняется предварительный поиск лида (проверка на существование)
     * для ускорения выполнения метода.
     */
    public static getLeadsByLeadIdEvents<ThrowOnError extends boolean = false>(options: Options<GetLeadsByLeadIdEventsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetLeadsByLeadIdEventsResponse, GetLeadsByLeadIdEventsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/leads/{lead_id}/events/',
            ...options
        });
    }
    
    /**
     * Передать лид в работу.
     *
     * На основе лида создается инфоповод, который передается в работу.
     * Если лид является временным, то создать постоянный лид.
     */
    public static postLeadsByLeadIdForward<ThrowOnError extends boolean = false>(options: Options<PostLeadsByLeadIdForwardData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostLeadsByLeadIdForwardResponse, PostLeadsByLeadIdForwardError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/leads/{lead_id}/forward/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Взять лид в работу.
     *
     * На основе лида создается инфоповод, который берется в работу,
     * и новость заданного типа.
     * Если лид является временным, то создать постоянный лид.
     */
    public static postLeadsByLeadIdPick<ThrowOnError extends boolean = false>(options: Options<PostLeadsByLeadIdPickData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostLeadsByLeadIdPickResponse, PostLeadsByLeadIdPickError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/leads/{lead_id}/pick/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Пометить лид как прочитанный.
     *
     * Не выполняется предварительный поиск лида (проверка на существование),
     * т.к. событие может относиться как к постоянному, так и временному лиду.
     */
    public static postLeadsByLeadIdRead<ThrowOnError extends boolean = false>(options: Options<PostLeadsByLeadIdReadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, PostLeadsByLeadIdReadError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/leads/{lead_id}/read/',
            ...options
        });
    }
    
}

export class NewsService {
    /**
     * Добавить новость.
     */
    public static postNews<ThrowOnError extends boolean = false>(options: Options<PostNewsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsResponse, PostNewsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть холст новостей.
     */
    public static getNewsCanvas<ThrowOnError extends boolean = false>(options?: Options<GetNewsCanvasData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetNewsCanvasResponse, GetNewsCanvasError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/canvas/',
            ...options
        });
    }
    
    /**
     * Обновить холст новостей.
     */
    public static patchNewsCanvas<ThrowOnError extends boolean = false>(options: Options<PatchNewsCanvasData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchNewsCanvasResponse, PatchNewsCanvasError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/canvas/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить коды.
     */
    public static deleteNewsCanvasCodes<ThrowOnError extends boolean = false>(options: Options<DeleteNewsCanvasCodesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteNewsCanvasCodesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/canvas/codes/',
            ...options
        });
    }
    
    /**
     * Добавить коды.
     */
    public static postNewsCanvasCodes<ThrowOnError extends boolean = false>(options: Options<PostNewsCanvasCodesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsCanvasCodesResponse, PostNewsCanvasCodesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/canvas/codes/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Создать и опубликовать новость из холста новостей.
     */
    public static postNewsCanvasPublish<ThrowOnError extends boolean = false>(options: Options<PostNewsCanvasPublishData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsCanvasPublishResponse, PostNewsCanvasPublishError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/canvas/publish/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть список новостей с отложенной публикацией.
     *
     * Сортировать новости с отложенной публикацией так, чтобы сначала
     * выводились новости, отложенные "до звонка", а после новости шли в
     * порядке возрастания времени запланированной публикации.  В качестве
     * курсора использовать номер строки.
     */
    public static getNewsDelayed<ThrowOnError extends boolean = false>(options: Options<GetNewsDelayedData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsDelayedResponse, GetNewsDelayedError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/delayed/',
            ...options
        });
    }
    
    /**
     * Отправить новости в отвал.
     */
    public static postNewsDispose<ThrowOnError extends boolean = false>(options: Options<PostNewsDisposeData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsDisposeResponse, PostNewsDisposeError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/dispose/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть список новостей в отвале.
     */
    public static getNewsDisposed<ThrowOnError extends boolean = false>(options: Options<GetNewsDisposedData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsDisposedResponse, GetNewsDisposedError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/disposed/',
            ...options
        });
    }
    
    /**
     * Вернуть список новостей в работе.
     */
    public static getNewsInProgress<ThrowOnError extends boolean = false>(options: Options<GetNewsInProgressData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsInProgressResponse, GetNewsInProgressError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/in_progress/',
            ...options
        });
    }
    
    /**
     * Вернуть список новостей текущего пользователя.
     */
    public static getNewsMy<ThrowOnError extends boolean = false>(options: Options<GetNewsMyData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsMyResponse, GetNewsMyError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/my/',
            ...options
        });
    }
    
    /**
     * Вернуть список оригиналов новостей.
     */
    public static getNewsOriginal<ThrowOnError extends boolean = false>(options: Options<GetNewsOriginalData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsOriginalResponse, GetNewsOriginalError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/original/',
            ...options
        });
    }
    
    /**
     * Вернуть список выпущенных новостей.
     */
    public static getNewsPublished<ThrowOnError extends boolean = false>(options: Options<GetNewsPublishedData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsPublishedResponse, GetNewsPublishedError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/published/',
            ...options
        });
    }
    
    /**
     * Вернуть список пресетов фильтрации списка выпущенных новостей.
     */
    public static getNewsPublishedPresets<ThrowOnError extends boolean = false>(options?: Options<GetNewsPublishedPresetsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetNewsPublishedPresetsResponse, GetNewsPublishedPresetsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/published/presets/',
            ...options
        });
    }
    
    /**
     * Создать пресет фильтрации списка выпущенных новостей.
     */
    public static postNewsPublishedPresets<ThrowOnError extends boolean = false>(options: Options<PostNewsPublishedPresetsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsPublishedPresetsResponse, PostNewsPublishedPresetsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/published/presets/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить пресет фильтрации списка выпущенных новостей.
     */
    public static deleteNewsPublishedPresetsByPresetId<ThrowOnError extends boolean = false>(options: Options<DeleteNewsPublishedPresetsByPresetIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteNewsPublishedPresetsByPresetIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/published/presets/{preset_id}/',
            ...options
        });
    }
    
    /**
     * Обновить пресет фильтрации списка выпущенных новостей.
     */
    public static patchNewsPublishedPresetsByPresetId<ThrowOnError extends boolean = false>(options: Options<PatchNewsPublishedPresetsByPresetIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchNewsPublishedPresetsByPresetIdResponse, PatchNewsPublishedPresetsByPresetIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/published/presets/{preset_id}/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Изменить время запланированной публикации новостей.
     *
     * Публикация новости может быть перенесена на другое время, отложена
     * бессрочно ("до звонка") или осуществиться немедленно.
     */
    public static postNewsReschedule<ThrowOnError extends boolean = false>(options: Options<PostNewsRescheduleData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsRescheduleResponse, PostNewsRescheduleError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/reschedule/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть список маршрутов новостей.
     */
    public static getNewsRoutes<ThrowOnError extends boolean = false>(options?: Options<GetNewsRoutesData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetNewsRoutesResponse, GetNewsRoutesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/routes/',
            ...options
        });
    }
    
    /**
     * Обновить маршрут новостей.
     */
    public static patchNewsRoutesByRouteId<ThrowOnError extends boolean = false>(options: Options<PatchNewsRoutesByRouteIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchNewsRoutesByRouteIdResponse, PatchNewsRoutesByRouteIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/routes/{route_id}/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть список найденных новостей.
     */
    public static getNewsSearch<ThrowOnError extends boolean = false>(options: Options<GetNewsSearchData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsSearchResponse, GetNewsSearchError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/search/',
            ...options
        });
    }
    
    /**
     * Вернуть список новостей на выпуск.
     */
    public static getNewsWaiting<ThrowOnError extends boolean = false>(options: Options<GetNewsWaitingData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsWaitingResponse, GetNewsWaitingError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/waiting/',
            ...options
        });
    }
    
    /**
     * Удалить новость.
     */
    public static deleteNewsByNewsId<ThrowOnError extends boolean = false>(options: Options<DeleteNewsByNewsIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteNewsByNewsIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/',
            ...options
        });
    }
    
    /**
     * Вернуть новость.
     */
    public static getNewsByNewsId<ThrowOnError extends boolean = false>(options: Options<GetNewsByNewsIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsByNewsIdResponse, GetNewsByNewsIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/',
            ...options
        });
    }
    
    /**
     * Обновить новость.
     */
    public static patchNewsByNewsId<ThrowOnError extends boolean = false>(options: Options<PatchNewsByNewsIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchNewsByNewsIdResponse, PatchNewsByNewsIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Аннотировать тикеры компаний в текстовых полях новости.
     */
    public static postNewsByNewsIdAnnotate<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdAnnotateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdAnnotateResponse, PostNewsByNewsIdAnnotateError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/annotate/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Аннотировать запрещенные организации в текстовых полях новости.
     */
    public static postNewsByNewsIdAnnotateForbidden<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdAnnotateForbiddenData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdAnnotateForbiddenResponse, PostNewsByNewsIdAnnotateForbiddenError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/annotate_forbidden/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть заметку АСОИ.
     */
    public static getNewsByNewsIdAsoiNote<ThrowOnError extends boolean = false>(options: Options<GetNewsByNewsIdAsoiNoteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsByNewsIdAsoiNoteResponse, GetNewsByNewsIdAsoiNoteError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/asoi_note/',
            ...options
        });
    }
    
    /**
     * Вернуть список авторов.
     */
    public static getNewsByNewsIdAuthors<ThrowOnError extends boolean = false>(options: Options<GetNewsByNewsIdAuthorsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsByNewsIdAuthorsResponse, GetNewsByNewsIdAuthorsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/authors/',
            ...options
        });
    }
    
    /**
     * Добавить авторов.
     */
    public static postNewsByNewsIdAuthors<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdAuthorsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdAuthorsResponse, PostNewsByNewsIdAuthorsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/authors/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить автора.
     */
    public static deleteNewsByNewsIdAuthorsByUserId<ThrowOnError extends boolean = false>(options: Options<DeleteNewsByNewsIdAuthorsByUserIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteNewsByNewsIdAuthorsByUserIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/authors/{user_id}/',
            ...options
        });
    }
    
    /**
     * Удалить коды.
     */
    public static deleteNewsByNewsIdCodes<ThrowOnError extends boolean = false>(options: Options<DeleteNewsByNewsIdCodesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteNewsByNewsIdCodesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/codes/',
            ...options
        });
    }
    
    /**
     * Вернуть список кодов.
     */
    public static getNewsByNewsIdCodes<ThrowOnError extends boolean = false>(options: Options<GetNewsByNewsIdCodesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsByNewsIdCodesResponse, GetNewsByNewsIdCodesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/codes/',
            ...options
        });
    }
    
    /**
     * Добавить коды.
     */
    public static postNewsByNewsIdCodes<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdCodesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdCodesResponse, PostNewsByNewsIdCodesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/codes/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть список комментариев к новости.
     */
    public static getNewsByNewsIdComments<ThrowOnError extends boolean = false>(options: Options<GetNewsByNewsIdCommentsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsByNewsIdCommentsResponse, GetNewsByNewsIdCommentsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/comments/',
            ...options
        });
    }
    
    /**
     * Добавить комментарий.
     */
    public static postNewsByNewsIdComments<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdCommentsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdCommentsResponse, PostNewsByNewsIdCommentsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/comments/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Прочитать комментарий к новости.
     *
     * Комментарии к новости, предшествующие тому комментарию, идентификатор
     * которого был передан, также помечаются как прочитанные.
     */
    public static postNewsByNewsIdCommentsByCommentIdRead<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdCommentsByCommentIdReadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdCommentsByCommentIdReadResponse, PostNewsByNewsIdCommentsByCommentIdReadError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/comments/{comment_id}/read/',
            ...options
        });
    }
    
    /**
     * Вернуть список событий новости.
     */
    public static getNewsByNewsIdEvents<ThrowOnError extends boolean = false>(options: Options<GetNewsByNewsIdEventsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsByNewsIdEventsResponse, GetNewsByNewsIdEventsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/events/',
            ...options
        });
    }
    
    /**
     * Создать дочернюю новость для расширения.
     */
    public static postNewsByNewsIdExtend<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdExtendData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdExtendResponse, PostNewsByNewsIdExtendError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/extend/',
            ...options
        });
    }
    
    /**
     * Вернуть связи.
     */
    public static getNewsByNewsIdLinks<ThrowOnError extends boolean = false>(options: Options<GetNewsByNewsIdLinksData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsByNewsIdLinksResponse, GetNewsByNewsIdLinksError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/links/',
            ...options
        });
    }
    
    /**
     * Удалить связь.
     */
    public static deleteNewsByNewsIdLinksByChildIdByTypeId<ThrowOnError extends boolean = false>(options: Options<DeleteNewsByNewsIdLinksByChildIdByTypeIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteNewsByNewsIdLinksByChildIdByTypeIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/links/{child_id}/{type_id}/',
            ...options
        });
    }
    
    /**
     * Вернуть настройки уведомлений о событиях новости.
     */
    public static getNewsByNewsIdNotifications<ThrowOnError extends boolean = false>(options: Options<GetNewsByNewsIdNotificationsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsByNewsIdNotificationsResponse, GetNewsByNewsIdNotificationsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/notifications/',
            ...options
        });
    }
    
    /**
     * Изменить настройки уведомлений о событиях новости.
     */
    public static postNewsByNewsIdNotifications<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdNotificationsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdNotificationsResponse, PostNewsByNewsIdNotificationsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/notifications/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть предыдущую версию новости.
     */
    public static getNewsByNewsIdOriginal<ThrowOnError extends boolean = false>(options: Options<GetNewsByNewsIdOriginalData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsByNewsIdOriginalResponse, GetNewsByNewsIdOriginalError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/original/',
            ...options
        });
    }
    
    /**
     * Взять новость на редактирование.
     */
    public static postNewsByNewsIdPick<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdPickData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdPickResponse, PostNewsByNewsIdPickError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/pick/',
            ...options
        });
    }
    
    /**
     * Отправить новость на публикацию.
     */
    public static postNewsByNewsIdPublish<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdPublishData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdPublishResponse, PostNewsByNewsIdPublishError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/publish/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Пометить новость как прочитанную.
     */
    public static postNewsByNewsIdRead<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdReadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdReadResponse, PostNewsByNewsIdReadError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/read/',
            ...options
        });
    }
    
    /**
     * Вернуть новость пользователю.
     */
    public static postNewsByNewsIdRecall<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdRecallData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdRecallResponse, PostNewsByNewsIdRecallError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/recall/',
            ...options
        });
    }
    
    /**
     * Вернуть связанные с новостью материалы.
     */
    public static getNewsByNewsIdRelations<ThrowOnError extends boolean = false>(options: Options<GetNewsByNewsIdRelationsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsByNewsIdRelationsResponse, GetNewsByNewsIdRelationsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/relations/',
            ...options
        });
    }
    
    /**
     * Создать дочернюю новость для переопубликования.
     */
    public static postNewsByNewsIdRepublish<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdRepublishData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdRepublishResponse, PostNewsByNewsIdRepublishError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/republish/',
            ...options
        });
    }
    
    /**
     * Переопубликовать новость без редактирования.
     */
    public static postNewsByNewsIdRepublishUnedited<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdRepublishUneditedData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdRepublishUneditedResponse, PostNewsByNewsIdRepublishUneditedError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/republish/unedited/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Создать дочернюю новость для аннулирования.
     */
    public static postNewsByNewsIdRevoke<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdRevokeData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdRevokeResponse, PostNewsByNewsIdRevokeError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/revoke/',
            ...options
        });
    }
    
    /**
     * Изменить коды направлений публикации.
     */
    public static patchNewsByNewsIdRouteCodes<ThrowOnError extends boolean = false>(options: Options<PatchNewsByNewsIdRouteCodesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchNewsByNewsIdRouteCodesResponse, PatchNewsByNewsIdRouteCodesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/route_codes/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Отправить новость на редактирование.
     */
    public static postNewsByNewsIdSend<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdSendData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdSendResponse, PostNewsByNewsIdSendError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/send/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Отправить новость на ящик АСОИ выбранным пользователям и почтовым
     * группам.
     */
    public static postNewsByNewsIdSendToAsoi<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdSendToAsoiData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsByNewsIdSendToAsoiResponse, PostNewsByNewsIdSendToAsoiError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/send_to_asoi/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Выполнить валидацию данных новости.
     */
    public static postNewsByNewsIdValidate<ThrowOnError extends boolean = false>(options: Options<PostNewsByNewsIdValidateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, PostNewsByNewsIdValidateError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/validate/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть версии новости и разницы между ними.
     */
    public static getNewsByNewsIdVersions<ThrowOnError extends boolean = false>(options: Options<GetNewsByNewsIdVersionsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsByNewsIdVersionsResponse, GetNewsByNewsIdVersionsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/news/{news_id}/versions/',
            ...options
        });
    }
    
}

export class NewsbreaksService {
    /**
     * Вернуть список инфоповодов.
     */
    public static getNewsbreaks<ThrowOnError extends boolean = false>(options: Options<GetNewsbreaksData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsbreaksResponse, GetNewsbreaksError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/newsbreaks/',
            ...options
        });
    }
    
    /**
     * Вернуть инфоповод.
     */
    public static getNewsbreaksByNewsbreakId<ThrowOnError extends boolean = false>(options: Options<GetNewsbreaksByNewsbreakIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsbreaksByNewsbreakIdResponse, GetNewsbreaksByNewsbreakIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/newsbreaks/{newsbreak_id}/',
            ...options
        });
    }
    
    /**
     * Вернуть список событий инфоповода.
     */
    public static getNewsbreaksByNewsbreakIdEvents<ThrowOnError extends boolean = false>(options: Options<GetNewsbreaksByNewsbreakIdEventsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetNewsbreaksByNewsbreakIdEventsResponse, GetNewsbreaksByNewsbreakIdEventsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/newsbreaks/{newsbreak_id}/events/',
            ...options
        });
    }
    
    /**
     * Взять инфоповод в работу.
     *
     * На основе инфоповода создается черновик новости выбранного типа.
     */
    public static postNewsbreaksByNewsbreakIdPick<ThrowOnError extends boolean = false>(options: Options<PostNewsbreaksByNewsbreakIdPickData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsbreaksByNewsbreakIdPickResponse, PostNewsbreaksByNewsbreakIdPickError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/newsbreaks/{newsbreak_id}/pick/',
            ...options
        });
    }
    
    /**
     * Пометить инфоповод как прочитанный.
     */
    public static postNewsbreaksByNewsbreakIdRead<ThrowOnError extends boolean = false>(options: Options<PostNewsbreaksByNewsbreakIdReadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsbreaksByNewsbreakIdReadResponse, PostNewsbreaksByNewsbreakIdReadError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/newsbreaks/{newsbreak_id}/read/',
            ...options
        });
    }
    
    /**
     * Отклонить инфоповод.
     */
    public static postNewsbreaksByNewsbreakIdReject<ThrowOnError extends boolean = false>(options: Options<PostNewsbreaksByNewsbreakIdRejectData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNewsbreaksByNewsbreakIdRejectResponse, PostNewsbreaksByNewsbreakIdRejectError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/newsbreaks/{newsbreak_id}/reject/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class NotificationsService {
    /**
     * Вернуть настройки уведомлений.
     */
    public static getNotifications<ThrowOnError extends boolean = false>(options?: Options<GetNotificationsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetNotificationsResponse, GetNotificationsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/notifications/',
            ...options
        });
    }
    
    /**
     * Изменить настройки уведомлений.
     */
    public static postNotifications<ThrowOnError extends boolean = false>(options: Options<PostNotificationsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNotificationsResponse, PostNotificationsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/notifications/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить подписку на уведомления APNS.
     */
    public static deleteNotificationsApnsV1DevicesByDeviceTokenRegistrationsByWebsitePushId<ThrowOnError extends boolean = false>(options: Options<DeleteNotificationsApnsV1DevicesByDeviceTokenRegistrationsByWebsitePushIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteNotificationsApnsV1DevicesByDeviceTokenRegistrationsByWebsitePushIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/notifications/apns/v1/devices/{device_token}/registrations/{website_push_id}',
            ...options
        });
    }
    
    /**
     * Создать подписку на уведомления APNS.
     */
    public static postNotificationsApnsV1DevicesByDeviceTokenRegistrationsByWebsitePushId<ThrowOnError extends boolean = false>(options: Options<PostNotificationsApnsV1DevicesByDeviceTokenRegistrationsByWebsitePushIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNotificationsApnsV1DevicesByDeviceTokenRegistrationsByWebsitePushIdResponse, PostNotificationsApnsV1DevicesByDeviceTokenRegistrationsByWebsitePushIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/notifications/apns/v1/devices/{device_token}/registrations/{website_push_id}',
            ...options
        });
    }
    
    /**
     * Логировать ошибки APNS.
     */
    public static postNotificationsApnsV1Log<ThrowOnError extends boolean = false>(options: Options<PostNotificationsApnsV1LogData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, PostNotificationsApnsV1LogError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/notifications/apns/v1/log',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Сформировать APNS Push Package.
     */
    public static postNotificationsApnsV2PushPackagesByWebsitePushId<ThrowOnError extends boolean = false>(options: Options<PostNotificationsApnsV2PushPackagesByWebsitePushIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<unknown, PostNotificationsApnsV2PushPackagesByWebsitePushIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/notifications/apns/v2/pushPackages/{website_push_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Создать подписку на push-уведомления.
     */
    public static postNotificationsSubscriptions<ThrowOnError extends boolean = false>(options: Options<PostNotificationsSubscriptionsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostNotificationsSubscriptionsResponse, PostNotificationsSubscriptionsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/notifications/subscriptions/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить подписку на push-уведомления.
     */
    public static deleteNotificationsSubscriptionsBySubscriptionId<ThrowOnError extends boolean = false>(options: Options<DeleteNotificationsSubscriptionsBySubscriptionIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteNotificationsSubscriptionsBySubscriptionIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/notifications/subscriptions/{subscription_id}/',
            ...options
        });
    }
    
}

export class ReferencesService {
    /**
     * Вернуть справочные данные.
     */
    public static getReferences<ThrowOnError extends boolean = false>(options?: Options<GetReferencesData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetReferencesResponse, GetReferencesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/references/',
            ...options
        });
    }
    
}

export class SourcesService {
    /**
     * Удалить источники вместе с потомками (пометить).
     */
    public static deleteSources<ThrowOnError extends boolean = false>(options: Options<DeleteSourcesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteSourcesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/sources/',
            ...options
        });
    }
    
    /**
     * Вернуть список источников.
     */
    public static getSources<ThrowOnError extends boolean = false>(options?: Options<GetSourcesData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSourcesResponse, GetSourcesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/sources/',
            ...options
        });
    }
    
    /**
     * Добавить источник.
     */
    public static postSources<ThrowOnError extends boolean = false>(options: Options<PostSourcesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSourcesResponse, PostSourcesError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/sources/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Удалить источник.
     */
    public static deleteSourcesBySourceId<ThrowOnError extends boolean = false>(options: Options<DeleteSourcesBySourceIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, DeleteSourcesBySourceIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/sources/{source_id}/',
            ...options
        });
    }
    
    /**
     * Вернуть источник.
     */
    public static getSourcesBySourceId<ThrowOnError extends boolean = false>(options: Options<GetSourcesBySourceIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSourcesBySourceIdResponse, GetSourcesBySourceIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/sources/{source_id}/',
            ...options
        });
    }
    
    /**
     * Обновить источник.
     */
    public static patchSourcesBySourceId<ThrowOnError extends boolean = false>(options: Options<PatchSourcesBySourceIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchSourcesBySourceIdResponse, PatchSourcesBySourceIdError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/sources/{source_id}/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Вернуть список ошибок.
     */
    public static getSourcesBySourceIdErrors<ThrowOnError extends boolean = false>(options: Options<GetSourcesBySourceIdErrorsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSourcesBySourceIdErrorsResponse, GetSourcesBySourceIdErrorsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/sources/{source_id}/errors/',
            ...options
        });
    }
    
    /**
     * Вернуть список логов.
     */
    public static getSourcesBySourceIdLogs<ThrowOnError extends boolean = false>(options: Options<GetSourcesBySourceIdLogsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSourcesBySourceIdLogsResponse, GetSourcesBySourceIdLogsError, ThrowOnError>({
            security: [
                {
                    name: 'Authorization',
                    type: 'apiKey'
                }
            ],
            url: '/sources/{source_id}/logs/',
            ...options
        });
    }
    
}